import './../Status.scss';
import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

interface Props {
    index: number;
}

export default function GriffinStatus(props: Props) {
    const [snAvailL1, setAvailL1] = useState(false);
    const [snJammerL1, setJammerL1] = useState(false);
    const [snSpooferL1, setSpooferL1] = useState(false);
    const [snAvailL2, setAvailL2] = useState(false);
    const [snJammerL2, setJammerL2] = useState(false);
    const [snSpooferL2, setSpooferL2] = useState(false);

    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    
    const SNTime = layerData.status.Time;
    const Status = layerData.status.GristStatus;
    
    useEffect(() => {
        if((props.index >= 0) && (props.index < Status.length)) {
            var jammerL1 = false;
            var spooferL1 = false;
            var jammerL2 = false;
            var spooferL2 = false;
            if(Status[props.index].BF.Array.length > 0) {
                if(Status[props.index].BF.Array[0].Jammer.x.length > 0) {
                    jammerL1 = true;
                }
                if(Status[props.index].BF.Array[1].Jammer.x.length > 0) {
                    jammerL2 = true;
                }
                if(Status[props.index].BF.Array[0].Spoofer.x.length > 0) {
                    spooferL1 = true;
                }
                if(Status[props.index].BF.Array[1].Spoofer.x.length > 0) {
                    spooferL2 = true;
                }
                setAvailL1(true);
                setJammerL1(jammerL1);
                setSpooferL1(spooferL1);
                setAvailL2(true);
                setJammerL2(jammerL2);
                setSpooferL2(spooferL2);
            } else {
                setAvailL1(false);
                setJammerL1(false);
                setSpooferL1(false);
                setAvailL2(false);
                setJammerL2(false);
                setSpooferL2(false);
            }
        } else {
            setAvailL1(false);
            setJammerL1(false);
            setSpooferL1(false);
            setAvailL2(false);
            setJammerL2(false);
            setSpooferL2(false);
        }
    }, [SNTime]);
    
    return (
	<div>
            <Table><TableBody>
                <TableRow className='name_row' style={{border: '1px solid rgba(0, 0, 0, 1)', width: '100%', maxWidth: '90%', margin: '0 auto', backgroundColor: 'black', height: '10%'}}>
                    <TableCell colSpan={1} style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', margin: '5px', backgroundColor: 'black'}} padding='none'>
                        { snAvailL1 && snJammerL1 && snSpooferL1 && <button className="bnt_orange_flash">L1 Jammer/Spoofer</button> }
                        { snAvailL1 && snJammerL1 && (!snSpooferL1) && <button className="bnt_orange_flash">L1 Jammer</button> }
                        { snAvailL1 && (!snJammerL1) && snSpooferL1 && <button className="bnt_orange_flash">L1 Spoofer</button> }
                        { snAvailL1 && (!snJammerL1) && (!snSpooferL1) && <button className="bnt_green">L1 No Detection</button> }
                        { (!snAvailL1) && <button className="bnt_grey">L1 No Detection</button> }
                    </TableCell>
                    <TableCell colSpan={1} style={{border: '1px solid rgba(0, 0, 0, 1)', width: '50%', margin: '5px', backgroundColor: 'black'}} padding='none'>
                        { snAvailL2 && snJammerL2 && snSpooferL2 && <button className="bnt_orange_flash">L2 Jammer/Spoofer</button> }
                        { snAvailL2 && snJammerL2 && (!snSpooferL2) && <button className="bnt_orange_flash">L2 Jammer</button> }
                        { snAvailL2 && (!snJammerL2) && snSpooferL2 && <button className="bnt_orange_flash">L2 Spoofer</button> }
                        { snAvailL2 && (!snJammerL2) && (!snSpooferL2) && <button className="bnt_green">L2 No Detection</button> }
                        { (!snAvailL2) && <button className="bnt_grey">L2 No Detection</button> }
                    </TableCell>
		</TableRow>
            </TableBody></Table>
        </div>
    )
}
